module.exports = __webpack_public_path__ + "static/img/companyProducts4.d118f1b9.png";